'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).service('settings', ['$localStorage', '$sessionStorage', 'Auth', 'enumerators', function ($localStorage, $sessionStorage, Auth, enumerators) {
	var self = {};

	// Properties
	self.isSigned = false;
	self.email = $localStorage.email;
	self.userName = $localStorage.userName;
	self.userId = $localStorage.userId;
	self.groups = $localStorage.groups;
	self.avatar = $localStorage.avatar;
	self.permissions = $localStorage.permissions;
	self.webPushToken = $localStorage.webPushToken;
	self.redirectTo = {};

	if (self.userId) {
		self.isSigned = true;
	}

	// Methods
	self.setUser = function (user) {
		
		self.email = $localStorage.email = user.email;
		self.userName = $localStorage.userName = user.displayName;
		self.userId = $localStorage.userId = user.userId;
		self.groups = $localStorage.groups = user.groups;
		self.avatar = $localStorage.avatar = user.imageAvatar;
		self.permissions = $localStorage.permissions = user.permissions;
		self.isSigned = true;
		
		if (self.webPushToken) {
			Auth.refreshFcmToken({
				deviceToken: self.webPushToken
			}, function (response) {
			}, function (error) {
			});
		}
	}

	self.setRedirect = function (state, params) {
		self.redirectTo.state = state;
		self.redirectTo.params = params;
	}

	self.clearRedirect = function () {
		self.redirectTo = {};
	}

	self.setWebPushToken = function (token) {
		self.webPushToken = $localStorage.webPushToken = token;

		if (self.webPushToken && self.isSigned) {
			Auth.refreshFcmToken({
				deviceToken: self.webPushToken
			}, function (response) {
			}, function (error) {
			});
		}
	}

	self.signOut = function () {
		if (self.isSigned) {
			Auth.logout(function (response) {
			}, function (error) {
			});
		}

		try {

			const _webPushToken = self.webPushToken;

			window.localStorage.clear();
			$localStorage = {};

			self.isSigned = false;
			self.email = null;
			self.userName = null;
			self.userId = null;
			self.groups = null;
			self.avatar = null;
			self.permissions = null;


			if (_webPushToken) {
				self.setWebPushToken(_webPushToken);
			}

			$sessionStorage.empty();
		} catch (err) {
			// console.log(err);
		}
	}

	self.clearSessionFilters = function () {
		$sessionStorage.colorsRequestsContextFilter = null;
		$sessionStorage.colorsRequestsContextFilter_Customer = null;
	}

	if (self.webPushToken && self.isSigned) {
		Auth.refreshFcmToken({
			deviceToken: self.webPushToken
		}, function (response) {
		}, function (error) {
		});
	}

	self.isColorsUserGroupByName = function (_input) {
		if (!_input) return false;
		if (!self || !self.groups) return false;
		
		const groupNames = Object.keys(enumerators.enumGroupsColorsRequests);
		if (groupNames.indexOf(_input) == -1) {
			return false;
		}
		const groupId = enumerators.enumGroupsColorsRequests[_input];

		if (!Array.isArray(self.groups)) return false;
		
		if (self.groups.map(g => g.groupId).indexOf(groupId) == -1) {
			return false;
		}
		
		return true;
	}

	return self;
}]);